export default "__VITE_ASSET__D7sd_W9C__"